export function IncidentDetailPanelLoadingPlaceholder() {
  return (
    <div className="placeholder-glow">
      <div className="placeholder col-8"></div>
      <div className="placeholder col-4"></div>
      <div className="placeholder col-7"></div>
      <div className="placeholder col-5"></div>
      <div className="placeholder col-3"></div>
    </div>
  );
}

export function IncidentDetailMapLoadingPlaceholder() {
  return (
    <div className="h-100 placeholder-glow">
      <div className="w-100 h-100 placeholder"></div>
    </div>
  );
}
